import { render } from "./DialogError.vue?vue&type=template&id=51f29113&scoped=true"
import script from "./DialogError.vue?vue&type=script&lang=js"
export * from "./DialogError.vue?vue&type=script&lang=js"

import "./DialogError.vue?vue&type=style&index=0&id=51f29113&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f29113"]])

export default __exports__